import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { theme } from '~/theme';
import { breakpoints } from '~/theme/breakpoints';

export const CardWrapper = styled.div(({ disabled }: { disabled?: boolean }) => ({
    display: `${disabled ? 'none' : 'flex'}`,
    flexFlow: 'column nowrap',
    border: `1px solid ${theme.colors.black}`,
    borderRadius: theme.sizes.cornerRadius,
    padding: 20,
    margin: '16px 0',
}));

export const CardTitle = styled.div(() => ({
    fontSize: theme.fontSizes.xs,
    fontWeight: theme.fontWeights.medium,
    textTransform: 'uppercase',
}));

export const CardFreightPrice = styled.div(() => ({
    fontSize: theme.fontSizes.xs,
    fontWeight: theme.fontWeights.medium,
    marginLeft: theme.space[3],
}));

export const CardDeliveryDays = styled.div(() => ({
    fontSize: theme.fontSizes.xs,
    paddingTop: theme.space[2],
}));

export const CardInfoWrapper = styled.div(() => ({
    position: 'relative',
    paddingLeft: theme.space[6],
    width: '100%',
}));

export const CardRadioWrapper = styled.div(() => ({
    position: 'absolute',
    left: 0,
    top: theme.space[1],
}));

export const CardDeliveryAddressInfo = styled.div<{ isHidden?: boolean }>(
    () => ({
        display: 'flex',
        flexDirection: 'column',
        fontSize: theme.fontSizes.xs,
        borderTop: `1px solid ${theme.colors.grey40}`,
        paddingTop: theme.space[2],
        marginTop: theme.space[2],
    }),
    ifProp('isHidden', () => ({
        opacity: 0,
        position: 'absolute',
        pointerEvents: 'none',
        visibility: 'hidden',
    })),
);

export const CardDeliveryAddressTitle = styled.div(() => ({
    fontWeight: theme.fontWeights.medium,
    paddingBottom: theme.space[1],
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '80%',
    [breakpoints.md]: {
        maxWidth: '100%',
    },
}));

export const CardDeliveryAddressEdit = styled.div(() => ({
    fontWeight: theme.fontWeights.medium,
    textDecoration: 'underline',
    cursor: 'pointer',
    ':focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },
}));
